import React, { startTransition, useState, useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { Container, Card, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { API_URI } from '../Common/data';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Loader from '../loader/Loader';
import { toBlogPreview } from "../Common/blogPreview";

function Blogs() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [seo, setSeo] = useState({
    title: 'Cine Celebrate - Blogs',
    metaDescription: '',
    metaKeywords: '',
    canonicalUrl: '',
    ogImage: '',
    ogTitle: '',
    ogDescription: '',
  });

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/blog`).then(res => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API_URI}/blog/all`);
        if (response.status === 200) {
          const previewBlogs = (response?.data?.data || []).map((blog) =>
            toBlogPreview(blog)
          );
          startTransition(() => {
            setBlogs(previewBlogs);
          });
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);



  return (
    <>
      <Helmet>
        <title>
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
            ? seo.metaTitle
            : "Cine Celebrate - Blogs"}
        </title>
        <meta name="title" content={seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
          ? seo.metaTitle
          : "Cine Celebrate - Blogs"} />
        <meta
          name="description"
          content={
            seo.metaDescription && seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Cine Celebrate - Blogs"
          }
        />
        <meta
          name="keywords"
          content={seo?.metaKeywords && Array.isArray(seo?.metaKeywords) ? seo?.metaKeywords.join(", ") : "Private Theater, Celebration, Cine Celebrate"}
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <Navbar />

      <div className='news-banner news-banner3'>


        <h1>Latest Blogs</h1>
      </div>

      {loading && <Loader />}
      <section className="blogs-revamp">
        <div className="blogs-revamp__intro">
          <div>
            <p className="blogs-revamp__eyebrow">Latest Stories</p>
            <h2>Fresh notes from celebrations, screenings, and surprise planning.</h2>
            <p className="blogs-revamp__text">
              Browse practical ideas, inspiration, and moments from the Cine Celebrate world.
            </p>
          </div>
          <div className="blogs-revamp__meta">
            <span>Published</span>
            <strong>{blogs.length} articles</strong>
          </div>
        </div>

        <Container className="blogs-revamp__container">
          <Row className="g-4">
            {blogs.map((blog, index) => (
              <Col key={blog._id} lg={index === 0 ? 12 : 6} md={6} sm={12}>
                <Card
                  className={`blogs-revamp-card ${index === 0 ? "blogs-revamp-card--featured" : ""}`}
                  onClick={() => navigate(`/blog/${blog.slug}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="blogs-revamp-card__media">
                    <Card.Img
                      variant="top"
                      src={blog.displayImage}
                      alt={blog.title}
                      className="blogs-revamp-card__image"
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                    />
                    <span className="blogs-revamp-card__tag">New</span>
                  </div>

                  <Card.Body className="blogs-revamp-card__body">
                    <div className="blogs-revamp-card__header">
                      <span className="blogs-revamp-card__count">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div>
                        <p className="blogs-revamp-card__date">Cine Celebrate Journal</p>
                        <Card.Title className="blogs-revamp-card__title">
                          {blog.title}
                        </Card.Title>
                      </div>
                    </div>

                    <Card.Text className="blogs-revamp-card__excerpt">
                      {blog.excerpt}
                    </Card.Text>

                    <span className="blogs-revamp-card__link">
                      Read More
                    </span>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}

export default Blogs;
